import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { SERVER_IP } from "@/data/site";

export const CopyIpButton = ({ testId = "copy-ip-btn", subtitle }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(SERVER_IP);
    } catch (clipboardError) {
      const textarea = document.createElement("textarea");
      textarea.value = SERVER_IP;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);

      try {
        textarea.select();
        if (!document.execCommand("copy")) {
          throw new Error("The browser did not copy the server address.");
        }
      } catch (fallbackError) {
        console.error("Unable to copy the server address.", {
          clipboardError,
          fallbackError,
        });
        toast.error("Impossibile copiare l'IP", {
          description: `Copia manualmente: ${SERVER_IP}`,
        });
        document.body.removeChild(textarea);
        return;
      }

      document.body.removeChild(textarea);
    }
    setCopied(true);
    toast.success("IP copiato negli appunti!", {
      description: SERVER_IP,
    });
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      data-testid={testId}
      onClick={handleCopy}
      className="group w-full sm:w-auto bg-[#d4af37] text-[#0f1410] hover:bg-[#e6c04a] transition-all duration-300 px-8 py-4 rounded-none uppercase font-heading font-bold tracking-widest shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] flex flex-col items-center gap-0.5"
    >
      <span className="flex items-center gap-2 text-sm md:text-base">
        {copied ? (
          <Check className="w-5 h-5" />
        ) : (
          <Copy className="w-5 h-5" />
        )}
        Copia l'IP → {SERVER_IP}
      </span>
      {subtitle && (
        <span className="text-[11px] font-body font-normal tracking-normal normal-case opacity-80">
          {subtitle}
        </span>
      )}
    </button>
  );
};
